import { createApiAction } from '@app/packages/api/utils'
import type { ApiAnonymousParent, ApiAvatar, ApiPublicParentReview, ApiRequestReview, ApiSitter } from '@app/packages/api/v2/types/entities'
import type { ApiDataResponse } from '@app/packages/api/v2/types/misc'
import type {
  GetReviewsPublicFromParentsQuery,
  GetReviewsQuery,
  RequestReviewCreateRequest,
  RequestReviewQACreateRequest,
} from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export type ReviewsPageMeta = { total: number; total_pages: number; current_page: number }

export const getReviews = (query: GetReviewsQuery) =>
  createApiAction('getReviews', dispatch =>
    dispatch<ApiDataResponse<ApiRequestReview[]> & { meta: ReviewsPageMeta }>({ method: 'GET', endpoint: v2Path('/api/v2/reviews', query) })
  )

export const postReviews = (request: RequestReviewCreateRequest) =>
  createApiAction('postReviews', dispatch =>
    dispatch<{ data: ApiRequestReview }>({ method: 'POST', endpoint: '/api/v2/reviews', body: JSON.stringify(request) })
  )

export const postReviewsQA = (request: RequestReviewQACreateRequest) =>
  createApiAction('postReviewsQA', dispatch => dispatch<unknown>({ method: 'POST', endpoint: '/api/v2/reviews/qa', body: JSON.stringify(request) }))

export const getReviewsPublicFromParents = (query: GetReviewsPublicFromParentsQuery) =>
  createApiAction('getReviewsPublicFromParents', dispatch =>
    dispatch<{ data: ApiPublicParentReview[]; included: (ApiAnonymousParent | ApiAvatar | ApiSitter)[]; meta: ReviewsPageMeta }>({
      method: 'GET',
      endpoint: v2Path('/api/v2/reviews/public/from_parents', query),
    })
  )
